export enum BonusModeType {
  DEPOSIT_BONUS = '1',
  FREE_PLAY = '2',
  NON_STICKY = '3',
}
